// src/utils/authChannel.js

const CHANNEL_NAME = 'lymphomap-auth';

// Initialize the channel safely if supported by the browser
export const authChannel = 'BroadcastChannel' in self ? new BroadcastChannel(CHANNEL_NAME) : null;

/**
 * Initializes the global listener for cross-tab logout.
 * Call this once in your main app entry point (e.g., App.vue created/mounted).
 */
export const initAuthListener = () => {
  if (!authChannel) return;

  authChannel.onmessage = (e) => {
    if (e.data && e.data.cmd === 'logout') {
      window.localStorage.removeItem('token');
      window.location.href = '/';
    }
  };
};

/**
 * Broadcasts a logout command to all other open tabs.
 */
export const broadcastLogout = () => {
  if (!authChannel) return;
  
  authChannel.postMessage({ cmd: 'logout' });
};